import { render, staticRenderFns } from "./ResalesCredited.vue?vue&type=template&id=7e9bca6d"
import script from "./ResalesCredited.vue?vue&type=script&lang=js"
export * from "./ResalesCredited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports